/*
 * @Date: 2021-07-05 15:40:06
 * @LastEditors: wangyu
 * @LastEditTime: 2022-03-30 19:16:34
 * @FilePath: \qrcode\src\main.js
 */
// IE
// https://github.com/zloirock/core-js/blob/master/docs/2019-03-19-core-js-3-babel-and-a-look-into-the-future.md#babelpolyfill
import 'core-js/stable'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { Button } from 'vant'

Vue.use(Button)

import 'lib-flexible/flexible.js'

import { i18n } from './i18n'

new Vue({
  el: '#app',
  router,
  i18n,
  render: h => h(App)
})

console.log('version: 1.3.14')
